import API, { responseOf } from "./base";
import type { ProcessCategory } from "../model/ProcessCategory";

export const create = (category: ProcessCategory): Promise<ProcessCategory> =>
  responseOf(API.post("/process-categories", category));

export const get = (categoryId: string): Promise<ProcessCategory> =>
  responseOf(API.get(`/process-categories/${categoryId}`));

export const update = (
  processCategory: ProcessCategory,
): Promise<ProcessCategory> =>
  responseOf(
    API.put(`/process-categories/${processCategory.id}`, processCategory),
  );

// Delete not allowed as variable name
const remove = async (categoryId: string): Promise<void> => {
  await API.delete(`/process-categories/${categoryId}`);
};
export { remove as delete };

export const byOrganization = (
  organizationId: string,
): Promise<ProcessCategory[]> =>
  responseOf(
    API.get(`/process-categories/byOrganization/${organizationId}`, {
      public: true,
    }),
  );
